/**
 * Logging utilities para o core WebView/Corel
 */

/**
 * Máscara campos sensíveis (password/senha/token) em objetos antes de logar.
 */
export function maskSecrets(obj: any): any {
  try {
    if (!obj || typeof obj !== 'object') return obj;
    const json = JSON.stringify(obj, (key, value) => {
      const k = String(key).toLowerCase();
      if (k.includes('password') || k.includes('senha') || k.includes('token')) {
        return '***';
      }
      return value;
    });
    return JSON.parse(json);
  } catch {
    return obj;
  }
}


